import React from "react";
import { Flame, ShieldCheck, Zap, Lock } from "lucide-react";
import { Button } from "../ui/button";
import { CHECKOUT_URL, CTA_CHECKOUT_TEXT } from "../../data/mock";

const PriceOffer = () => {
  return (
    <section id="oferta" className="section-pad bg-gradient-to-b from-pink-50/70 to-white scroll-mt-4">
      <div className="max-w-4xl mx-auto px-4">
        {/* Scarcity banner */}
        <div className="mx-auto max-w-2xl text-center">
          <div className="inline-flex items-center gap-2 bg-red-50 border-2 border-red-300 text-red-700 rounded-2xl md:rounded-full px-4 py-2.5 text-[13px] md:text-[15px] font-bold shadow-sm">
            <Flame className="w-5 h-5 text-red-600 shrink-0" />
            <span className="leading-tight">
              Atenção: restam apenas <span className="underline decoration-2 decoration-red-500 text-red-800">5 vagas</span> para garantir todos os bônus gratuitamente.
            </span>
          </div>
        </div>

        {/* Offer card */}
        <div className="relative mt-5 md:mt-8 rounded-3xl overflow-hidden shadow-2xl border-2 border-pink-200 bg-white">
          {/* Ribbon */}
          <div className="bg-gradient-to-r from-pink-600 via-rose-500 to-pink-600 text-white text-center py-2.5 md:py-3 font-bold text-[12px] md:text-base uppercase tracking-wider px-3">
            🔥 Somente hoje — Mega Oferta com todos os bônus liberados
          </div>

          <div className="p-5 md:p-10 grid md:grid-cols-2 gap-6 md:gap-8 items-center">
            {/* Right: price (moved above list on mobile for impact) */}
            <div className="order-1 md:order-2 relative bg-gradient-to-br from-pink-50 to-rose-50 rounded-2xl p-5 md:p-8 border-2 border-pink-200">
              <div className="text-center">
                <div className="text-[11px] md:text-sm text-pink-900/70">De <span className="line-through">R$297,00</span> por apenas</div>
                <div className="mt-1.5 md:mt-2 flex items-end justify-center gap-1">
                  <span className="font-serif-display font-black text-3xl md:text-6xl text-pink-700 leading-none">11x</span>
                  <span className="font-serif-display font-black text-xl md:text-3xl text-pink-700 leading-none pb-0.5 md:pb-1">de</span>
                  <span className="font-serif-display font-black text-4xl md:text-7xl text-rose-600 leading-none tracking-tight">R$6,15</span>
                </div>
                <div className="mt-1.5 md:mt-2 text-[11px] md:text-sm text-pink-900/70">
                  ou <strong className="text-pink-800">R$56,90</strong> à vista no PIX
                </div>
              </div>

              <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer">
                <Button
                  size="lg"
                  className="mt-4 md:mt-6 w-full h-auto animate-pulse-soft bg-gradient-to-b from-pink-500 to-rose-600 hover:from-pink-600 hover:to-rose-700 text-white font-black text-[12px] sm:text-[13px] md:text-[15px] py-4 md:py-5 rounded-full shadow-lg leading-tight px-3 whitespace-normal break-words text-center"
                >
                  👉QUERO {CTA_CHECKOUT_TEXT}
                </Button>
              </a>

              <div className="mt-3 md:mt-4 grid grid-cols-3 gap-2 text-[10px] md:text-[11px] text-pink-900/70">
                <div className="flex flex-col items-center gap-1">
                  <Lock className="w-3.5 h-3.5 md:w-4 md:h-4 text-pink-600" />
                  <span>Compra segura</span>
                </div>
                <div className="flex flex-col items-center gap-1">
                  <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 text-pink-600" />
                  <span>Acesso imediato</span>
                </div>
                <div className="flex flex-col items-center gap-1">
                  <ShieldCheck className="w-3.5 h-3.5 md:w-4 md:h-4 text-pink-600" />
                  <span>Garantia 15 dias</span>
                </div>
              </div>
            </div>

            {/* Left: what you get */}
            <div className="order-2 md:order-1">
              <h3 className="font-serif-display font-black text-xl md:text-3xl text-pink-700 leading-tight text-center md:text-left">
                Você leva TUDO isto hoje:
              </h3>
              <ul className="mt-3 md:mt-4 space-y-2 text-pink-900 text-[13px] md:text-[15px]">
                <li>✅ <strong>1 mil artes prontas</strong> (Tags, Sacolas, Caixas, Adesivos, Kits)</li>
                <li>✅ <strong>18 Bônus exclusivos</strong> liberados</li>
                <li>✅ <strong>Bônus Especial:</strong> +300 artes Premium</li>
                <li>✅ <strong>Suporte personalizado</strong> por WhatsApp</li>
                <li>✅ <strong>Atualizações vitalícias</strong> — pague uma vez</li>
                <li>✅ <strong>Garantia de 15 dias</strong> ou seu dinheiro de volta</li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 md:mt-6 text-center text-[10px] md:text-xs text-pink-900/60 px-4">
          Pagamentos processados de forma 100% segura. Cartão de crédito, PIX ou boleto.
        </p>
      </div>
    </section>
  );
};

export default PriceOffer;
